import React, { Component } from "react";
import logosvg from "../assets/img/logo";
import { TimelineMax, Power4, Back } from "gsap";
import { Link } from "react-router-dom";
import { transition } from "./Utils/React3dNavigation";

class Logo extends Component {
  componentDidMount() {
    const letJ1 = document.getElementById("letJ1");
    const letO = document.getElementById("letO");
    const letJ2 = document.getElementById("letJ2");
    const letA = document.getElementById("letA");
    const horse = document.getElementById("horse");

    const tl = new TimelineMax({ delay: 1.2 });

    tl.staggerFrom(
      [letJ1, letO, letJ2, letA],
      0.6,
      {
        transform: "translateY(150px)",
        ease: Power4.easeOut,
        opacity: 1
      },
      0.1
    );
    tl.from(horse, 0.15, {
      transform: "translateX(70px) translateY(-250px) rotateX(20deg)",
      ease: Back.easeOut,
      opacity: 1,
      delay: 0.3
    });
  }

  render = () => {
    return (
      <div className="logoNav">
        <Link to="/" onClick={() => transition("/")}>
          <div id="logo" ref="logosvg">
            {logosvg}
          </div>
        </Link>

        <div id="navigation">
          <Link to="/work">
            <div className="link" onClick={() => transition("/work")}>
              WORK
            </div>
          </Link>

          <Link to="/contact">
            <div className="link" onClick={() => transition("/contact")}>
              CONTACT
            </div>
          </Link>
        </div>
      </div>
    );
  };
}

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.js